module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1005.3319da85.jpg";